module.exports = __webpack_public_path__ + "img/certificate-hover.7320f39.svg";